<header class="header-lite">
  <img class="header-lite__logo" src="assets/imgs/logo.svg" alt="Activo2 Logo" />
  <h1 class="header-lite__title">Activo2</h1>
</header>
